const rides = [
  {
    codename: 'florida-to-alaska',
    title: 'Florida to Alaska',
    startDate: '2022-06',
    starred: true,
    description: 'A four month trek across the US and Canada raising money for childhood cancer in memory of my cousin.',
  },
  {
    codename: 'seattle-washington-cascades',
    title: 'Seattle and Washington Cascades',
    startDate: '2025-11',
    description: 'A week-long loop through and around the Cascades and exploring Seattle.',
  },
  {
    codename: 'san-francisco-portland',
    title: 'San Francisco to Portland',
    startDate: '2024-11',
    description: 'Thanksgiving week riding up the remote coast of Northern California and Oregon.',
  },
  {
    codename: 'santa-cruz-big-basin',
    title: 'Santa Cruz Mountains Loop through Big Basin',
    startDate: '2024-02',
    description: 'A weekend trip through the redwoods.',
  },
  {
    codename: 'san-jose-to-los-angeles',
    title: 'San Jose to Los Angeles',
    startDate: '2023-11',
    description: 'Nine days down California\'s central coast.',
  },
  {
    codename: 'san-jose-labor-day-2023',
    title: 'San Jose Labor Day Loop',
    startDate: '2023-11',
    description: 'Labor Day weekend spent exploring Monterey Bay and the southern Santa Cruz Mountains.',
  },
  {
    codename: 'san-jose-yosemite',
    title: 'San Jose - Yosemite',
    startDate: '2023-06',
    description: 'Too lazy to fix a car tire, a weekend bike ride to Yosemite and back to meet up'
      + ' with some friends to hike with seemed like the better choice.',
  },
  {
    codename: 'san-jose-big-sur',
    title: 'San Jose - Big Sur',
    startDate: '2021-11',
    description: 'Thanksgiving loop down the Salinas Valley, across the coastal mountains, and back up along California\'s Highway 1.',
  },
  {
    codename: 'san-jose-mt-tam',
    title: 'San Jose - Mt. Tamalpais',
    startDate: '2021-10',
    description: 'A loop around the SF Bay Area to watch the air show and sleep with a view.',
  },
  {
    codename: 'rochester-niagara-falls',
    title: 'Rochester - Niagara Falls',
    startDate: '2021-05',
    description: 'One final riding adventure with my college friend to a world wonder.',
  },
  {
    codename: 'rochester-letchworth',
    title: 'Rochester - Letchworth',
    startDate: '2020-09',
    description: 'Exploring the "Grand Canyon of the East" with a couple college friends.',
  },
  {
    codename: 'tri-state-loop',
    title: 'Tri-State Loop',
    startDate: '2020-08',
    description: 'My first multi-day trip, exploring NY, NJ, and PA with my dog (and ending in disaster).',
  },
  {
    codename: 'north-bellmore-orient-point',
    title: 'North Bellmore - Orient Point',
    startDate: '2018-08',
    description: 'My first overnighter with some ambitious miles to the end of Long Island and back.',
  },
];

module.exports = { rides };
// export default rides;
